export enum MembersPageType {
  Details,
  Requests,
}
